import { render, staticRenderFns } from "./NewWidgetContainer.vue?vue&type=template&id=2743fec2&"
import script from "./NewWidgetContainer.vue?vue&type=script&lang=js&"
export * from "./NewWidgetContainer.vue?vue&type=script&lang=js&"
import style0 from "./NewWidgetContainer.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports